import React from "react";
import "./App.css";
import { CarouselMobile } from "./layouts/CarouselMobile";

function App() {
  return (
    <div style={{ height: "100vh" }}>
      <CarouselMobile />
    </div>
  );
}

export default App;
